import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { handleErrorMessage } from "../../../../helpers/methods";
import { getIndividualHousesData } from "../../AnalysisService";
import HousesFlipCards from "./HousesFlipCards";

interface CustomProps {
  profileId?: string;
  setIsLoading: Function;
  house: any;
}

const Houses = (props: CustomProps) => {
  const [housesData, setHousesData] = useState<any[]>([]);
  const { i18n } = useTranslation();

  useEffect(() => {
    getHouses();
  }, [i18n.language, props.house]);

  const getHouses = async () => {
    try {
      props.setIsLoading(true);
      const language = i18n.language.toLowerCase();
      const response = await getIndividualHousesData(
        props?.profileId!,
        props.house,
        language
      );
      setHousesData(response);
      props.setIsLoading(false);
    } catch (error: any) {
      props.setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  return (
    <Grid container py={1}>
      {housesData?.map((data: any) => {
        return <HousesFlipCards flipCardData={data} />;
      })}
    </Grid>
  );
};

export default Houses;
